import { StaffBasic } from './helpbutton-staff-basic.model';

export class DepartmentGroup {
    private groupNumber: number;
    private internalId: string;
    private secondsBeforeNextWave: number;
    private staffList: Array<StaffBasic>;

    constructor(groupNumber?: number, internalId?: string, secondsBeforeNextWave?: number, staffList?: Array<StaffBasic>) {
        this.groupNumber = groupNumber;
        this.internalId = internalId;
        this.secondsBeforeNextWave = secondsBeforeNextWave;
        this.staffList = staffList;
    }

    public get GroupNumber() {
        return this.groupNumber;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get SecondsBeforeNextWave() {
        return this.secondsBeforeNextWave;
    }
    public get StaffList() {
        return this.staffList;
    }
    public set GroupNumber(groupNumber) {
        this.groupNumber = groupNumber;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set SecondsBeforeNextWave(secondsBeforeNextWave) {
        this.secondsBeforeNextWave = secondsBeforeNextWave;
    }
    public set StaffList(staffList) {
        this.staffList = staffList;
    }
}
